import React from 'react'
import "./modules.scss"
import ListModules from './sections/listModules'
import MeetOurModules from './sections/meetOurModules'
import Letsgo from "../connectors/letsgo"

function Modules() {
  return (
    <div className='container-modules'>
      <div className='section-meet-our-modules'>
        <MeetOurModules />
      </div>
      <div className='section-list-modules'>
        <ListModules />
      </div>
      <div className="section-letsgo">
        <Letsgo />
      </div>
    </div>
  )
}

export default Modules